import { FC, useRef } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { AttachmentFilter } from './filters/attachment-filter.component';
import { ChannelFilter } from './filters/channel-filter.component';
import { SenderFilter } from './filters/sender-filter.component';
import { SearchBar, SearchBarRef } from './search-bar.component';

export const KeywordSearchWithFilters: FC = () => {
  const searchBarRef = useRef<SearchBarRef>(null);

  const focusSearchBar = () => {
    setTimeout(() => {
      searchBarRef.current?.focus();
    }, 300);
  };

  return (
    <div css={styles.container}>
      <SearchBar ref={searchBarRef} />
      <div css={styles.filtersContainer}>
        <ChannelFilter focusSearchBar={focusSearchBar} />
        <SenderFilter focusSearchBar={focusSearchBar} />
        <AttachmentFilter focusSearchBar={focusSearchBar} />
      </div>
    </div>
  );
};

const styles = {
  container: css({
    padding: theme.spacing(0.5, 1, 0, 1),
  }),
  filtersContainer: css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    width: '100%',

    '.dropdownFilterChipField': {
      outline: 'none',
      height: '24px',

      svg: {
        width: theme.spacing(1),
        height: theme.spacing(1),
      },

      p: {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },

      '.label': {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },
      '.label-prefix': {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },
    },
    '.dropdownFilterChipField[aria-expanded="true"]': {
      borderColor: theme.colorsV2.blue50(),
    },
  }),
};
